import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/portfolio/Nav";
import Hero from "@/components/portfolio/Hero";
import Work from "@/components/portfolio/Work";
import About from "@/components/portfolio/About";
import OnAI from "@/components/portfolio/OnAI";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import ClientMarquee from "@/components/portfolio/ClientMarquee";
import { scrollToId } from "@/lib/scroll";

export default function Portfolio() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash.slice(1)), 700);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main data-testid="portfolio-page" className="relative bg-white text-black">
      <Nav />
      <Hero />
      <ClientMarquee />
      <Work />
      <About />
      <OnAI />
      <Contact />
      <Footer />
    </main>
  );
}
